/**
 * Servicios
 */
//Importar el espacio de almacenamiento de base de datos firestore
import { pacientesStore,surgeryroomCollection } from '../firebase/config';

/**
 * Función que elimia un paciente de la lista de paciente pendientes de alta
 * @param {Object} paciente Recibe la información del paciente
 * @returns Devuelve el resultado de la petición
 */
export const deletePaciente = async (paciente) => {
    try {
      await pacientesStore
      .collection(surgeryroomCollection)
      .doc(paciente.id)
      .delete();
      return "success"
    } catch (error) {//Manejo de errores inesparados
        return error
    }
}

/**
 * Funcón que actualiza un paciente (actualiza su estatus)
 * @param {Object} paciente Recibe la información del paciente
 * @param {String} status Recibe el estado al que se actualizara el paciente
 * @param {Boolean} IsInOperacion Recibe si el paciente continuara en control de quirófano
 * @returns Devuelve el resultado de la petición
 */
export const updatePatient = async (paciente, status, IsInOperacion,ultimoEstatus) => {
  try{
    let notificacionesEnviadas = 0
    if(paciente.sendingnotification){
      notificacionesEnviadas = paciente.sendingnotification
    }
    notificacionesEnviadas = notificacionesEnviadas + 1

    if(ultimoEstatus === "Especial"){
      //Actualizar el campo Status de la colección asiciada al paciente
      await pacientesStore
      .collection(surgeryroomCollection)
      .doc(paciente.id)
      .update({
        Status : status,
        sendingnotification : notificacionesEnviadas
      })
    }
    else{
      //Actualizar el campo Status de la colección asiciada al paciente
      await pacientesStore
      .collection(surgeryroomCollection)
      .doc(paciente.id)
      .update({
        Status : status,
        lastEstatus : ultimoEstatus
      })
    }

    //Si el nuevo estatus del paciente es Especial o Salida se procede a solictar la eliminación de la colección
    //en otro caso se devuelve petición exitosa
    switch(status){
      case "Especial":
        if(IsInOperacion){
          return "success"
        }
        else{
          return deletePaciente(paciente)
        }
      case "Salida":
        return deletePaciente(paciente)
      case "Ambulatorio Alta":
        return deletePaciente(paciente)
      case "Cancelación":
        return deletePaciente(paciente)
      default:
        return "success"
    }
  }
  catch (error){//Manejo de errores inesparados
    return error
  }
}